module.exports = __webpack_public_path__ + "static/media/map-5.401b3d70.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/map-5.png
// module id = 587
// module chunks = 23